export const FIELDS = {
  ACCOUNT_ID: 'accountId',
  ACCOUNT_NAME: 'accountName',
  ALT_NUMBER: 'altMfr',
  BUY_PRICE: 'buyPrice',
  CLASS_ID: 'classId',
  COMMENT: 'comments',
  CONDITION_ID: 'conditionId',
  CONTACT_ID: 'contactId',
  CONVERTED_PRICE: 'convertedPrice',
  CONVERTED_TARGET_PRICE: 'convertedTargetPrice',
  CURRENCY_ID: 'currencyTypeId',
  HARMONIZED_CODE: 'harmonizedCode',
  LOT_NUMBER: 'lotCode',
  MFR: 'mfgName',
  NEEDS_BY_DATE: 'needsBy',
  NSN_NUMBER: 'nsnNumber',
  NOTE: 'customerNote',
  QTY: 'qtyOnHand',
  REFERRAL_SOURCE_ID: 'referalSourceId',
  REQ_FAX: 'reqFax',
  REQUEST_NOTE: 'reqNote',
  RFQ_DATE: 'rfqDate',
  RFQ_NUMBER: 'rfqNumber',
  SHIP_VIA_ID: 'shipViaId',
  TARGET_PRICE: 'targetPrice',
  TEMP: 'tempRating',
  TESTING_ID: 'testingId',
};
